import React, { useEffect, useState } from 'react';
import { Input, Select, Modal, message, Spin } from 'antd';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getAllSessions, deleteSession } from '../../../redux/features/sessions/sessionActions';
import { GrDocumentText } from "react-icons/gr";
import Pagination from '../../../components/Pagination/Pagination'
import { PrivateAxiosInstance } from '../../../services/createAxiosInstance'
import { URLs } from '../../../constants/apiEndpoints'
import { BsCollectionPlayFill } from "react-icons/bs";

const { Search } = Input;

function AllCollection() {
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [statusFilter, setStatusFilter] = useState('');
    const [currentPage, setCurrentPage] = useState(1); // Keep track of current page
    const [totalPages, setTotalPages] = useState(1)

    const navigate = useNavigate();
    const dispatch = useDispatch();


    const handleSearch = (value) => {
        setSearchText(value);
    };

    const handleStautsChange = (value) => {
        setStatusFilter(value);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async (page = 1, limit = 20, sortBy = "CreatedAt", sortOrder = "asc", searchValue = '', statusFilter = '') => {
        setLoading(true);
        try {
            const queryParams = new URLSearchParams({
                page: String(page),
                limit: '10',
                sortBy,
                sortOrder,
                search: searchValue, // Pass search to the API if supported
                status: statusFilter, // Pass KYC status to the API if supported
            }).toString();

            const res = await PrivateAxiosInstance.get(`${URLs.GET_EVENT_COLLECTIONS}?${queryParams}`);

            const data = res?.data?.events
            const totalPage = res?.data?.pages

            setFilteredData(data);
            setTotalPages(totalPage);
        } catch (error) {
            message.error('Failed to fetch user details');
            console.error("Error fetching users:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(currentPage, 15, 'CreatedAt', 'asc', searchText, statusFilter);
    }, [currentPage, searchText, statusFilter]);

    const tableHeaders = ['ID', 'Title', 'Create At', 'Update At', 'View', 'Action'];



    const showConfirm = (eventCollectionId) => {
        Modal.confirm({
            title: 'Confirm Delete',
            content: 'Are you sure you want to delete this record?',
            okText: 'Yes, Delete',
            cancelText: 'Cancel',
            onOk() {
                deleteCollection(eventCollectionId);
            },
        });
    };


    const deleteCollection = async (eventCollectionId) => {
        try {
            const res = await PrivateAxiosInstance.delete(`${URLs.DELETE_COLLECTION}/${eventCollectionId}`);
            console.log('res: ', res);
            message.success('Delete successfully!');
            fetchData();
        } catch (err) {
            console.log(err)
            const errorMessage = err.error || 'Failed to Delete Collection';
            message.error(errorMessage);
        }
    }

    return (
        <>
            <div className="font-poppins overflow-x-auto md:mt-[80px]">

                <Spin spinning={loading} fullscreen />

                <h2 className='text-white text-xl  md:text-2xl font-bold text-start mb-5 '>All Collection</h2>

                <div className="grid md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 md:gap-6 bg-background-secondary-color p-3  rounded-t-lg">

                    {/* Search bar */}
                    <div className=" ml-[-20px]  w-[400px] mb-3 md:ml-[0px] lg:ml-[P0px] mt-3 sm:mt-0 sm:ml-[0px] group">
                        <Search
                            placeholder="Search by name or email"
                            onSearch={handleSearch}
                            onChange={(e) => handleSearch(e.target.value)}
                            value={searchText}
                            style={{ width: 250 }}
                        />
                    </div>

                    {/* category dropdown */}
                    {/* <div className="w-full mb-2  mt-3 sm:mt-0 ml-[0px] group ">
                        <div className=" w-full mb-2   mt-3 sm:mt-0 sm:ml-[20px] group">
                            <Select
                                defaultValue="All"
                                style={{ width: 200 }}
                                onChange={handleStautsChange}
                            >
                                <Option value="">All</Option>
                                <Option value="active">Active</Option>
                                <Option value="inactive">Not Active</Option>
                            </Select>
                        </div>
                    </div> */}

                    {/* <div className='flex justify-end item-center'>
                        <Link to="/admin/session/add">
                            <button type="button"
                                className="px-3 py-2 mt-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Add Session</button>
                        </Link>

                    </div> */}
                </div>

                {/* Table headers */}
                <table className="min-w-full bg-white">
                    <thead className="bg-gray-950 whitespace-nowrap">
                        <tr>
                            {tableHeaders.map((header, index) => (
                                <th key={index} className="p-4 text-left text-sm font-medium font-poppins text-white">
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    {/* Table row */}
                    <tbody className="whitespace-normal">
                        {filteredData?.length > 0 ? (
                            filteredData?.map((data, index) => (
                                <tr key={index} className="bg-gray-800 odd:bg-gray-700 cursor-pointer hover:bg-red-900">

                                    <td className="p-4 text-sm text-gray-200 font-poppins">
                                        {data?.eventCollectionId}
                                    </td>
                                    <td className="p-4 text-sm max-w-[430px] text-gray-200 font-poppins  ">
                                        {data?.eventCollectionName}
                                    </td>
                                    <td className="p-4 text-sm max-w-[430px] text-gray-200 font-poppins ">
                                        {new Date(data?.createdAt).toLocaleDateString()}
                                    </td>
                                    <td className="p-4 text-sm text-gray-200 font-poppins">
                                        {new Date(data?.updatedAt).toLocaleDateString()}
                                    </td>


                                    {data?.events?.length > 0 ? (
                                        <td className="p-4 text-sm text-gray-200 font-poppins">
                                            <Link to={`/admin/collection/${data?.eventCollectionId}`}>
                                                <button className="mr-4 text-blue-500 hover:text-blue-700" title="Edit">
                                                    <BsCollectionPlayFill className=' w-5 h-5' />
                                                </button>
                                            </Link>
                                        </td>
                                    ) : (
                                        <td className="p-4 text-sm  text-gray-200 font-poppins">
                                            N/A
                                        </td>
                                    )}




                                    <td className="p-4">
                                        {/* <Link to={`/admin/session/edit/${data?.eventCollectionId}`}>
                                            <button className="mr-4" title="Edit">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 fill-blue-500 hover:fill-blue-700"
                                                    viewBox="0 0 348.882 348.882">
                                                    <path d="m333.988 11.758-.42-.383A43.363 43.363 0 0 0 304.258 0a43.579 43.579 0 0 0-32.104 14.153L116.803 184.231a14.993 14.993 0 0 0-3.154 5.37l-18.267 54.762c-2.112 6.331-1.052 13.333 2.835 18.729 3.918 5.438 10.23 8.685 16.886 8.685h.001c2.879 0 5.693-.592 8.362-1.76l52.89-23.138a14.985 14.985 0 0 0 5.063-3.626L336.771 73.176c16.166-17.697 14.919-45.247-2.783-61.418zM130.381 234.247l10.719-32.134.904-.99 20.316 18.556-.904.99-31.035 13.578zm184.24-181.304L182.553 197.53l-20.316-18.556L294.305 34.386c2.583-2.828 6.118-4.386 9.954-4.386 3.365 0 6.588 1.252 9.082 3.53l.419.383c5.484 5.009 5.87 13.546.861 19.03z"
                                                        data-original="#000000" />
                                                    <path
                                                        d="M303.85 138.388c-8.284 0-15 6.716-15 15v127.347c0 21.034-17.113 38.147-38.147 38.147H68.904c-21.035 0-38.147-17.113-38.147-38.147V100.413c0-21.034 17.113-38.147 38.147-38.147h131.587c8.284 0 15-6.716 15-15s-6.716-15-15-15H68.904C31.327 32.266.757 62.837.757 100.413v180.321c0 37.576 30.571 68.147 68.147 68.147h181.798c37.576 0 68.147-30.571 68.147-68.147V153.388c.001-8.284-6.715-15-14.999-15z"
                                                        data-original="#000000" />
                                                </svg>

                                            </button>
                                        </Link> */}

                                        <button onClick={() => showConfirm(data?.eventCollectionId)} title="Delete">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 fill-red-500 hover:fill-red-700" viewBox="0 0 24 24">
                                                <path d="M19 7a1 1 0 0 0-1 1v11.191A1.92 1.92 0 0 1 15.99 21H8.01A1.92 1.92 0 0 1 6 19.191V8a1 1 0 0 0-2 0v11.191A3.918 3.918 0 0 0 8.01 23h7.98A3.918 3.918 0 0 0 20 19.191V8a1 1 0 0 0-1-1Zm1-3h-4V2a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2H4a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2ZM10 4V3h4v1Z" data-original="#000000" />
                                                <path d="M11 17v-7a1 1 0 0 0-2 0v7a1 1 0 0 0 2 0Zm4 0v-7a1 1 0 0 0-2 0v7a1 1 0 0 0 2 0Z" data-original="#000000" />
                                            </svg>
                                        </button>
                                    </td>
                                    {/* </Link> */}

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={tableHeaders.length} className="text-center p-4">
                                    No Data Available
                                </td>
                            </tr>
                        )}
                    </tbody>

                </table>


                <>

                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange} />
                </>

            </div>
        </>
    );
}

export default AllCollection;
